import { couponStatus, enumStatus, redeemStatus, region_towship } from "@configs";
import { IAdvanceSearch, Typestate } from "@interfaces";
import { Checkbox, Col, Form, Modal, Row, Select } from "antd";
import { CheckboxValueType } from "antd/es/checkbox/Group";
import { useState } from "react";
import { useTranslation } from "react-i18next";
interface IProps {
  visible: boolean;
  callback: (params: IAdvanceSearch) => void;
}
// const init: Typestate = Object.keys(region_towship)[0]
export const AdvanceFilter = ({ visible, callback }: IProps) => {
  const { t } = useTranslation();
  const [state, setState] = useState<Typestate>();
  const [township, setTownship] = useState<string>("");
  const [redeem, setRedeem] = useState<CheckboxValueType[]>();
  const [coupon, setCoupon] = useState<CheckboxValueType[]>();
  const onChangeStatus = (checked: CheckboxValueType[]) => {
    setRedeem(checked);
  };
  const onChangeCouponStatus = (checked: CheckboxValueType[]) => {
    setCoupon(checked);
  };
  const handleSelectSate = (value: Typestate) => {
    setState(value);
  };
  const handleSelectTownship = (value: string) => {
    setTownship(value);
  };
  const sendFilter = async () => {
    const params = {
      ...(coupon && { couponStatus: coupon }),
      ...(redeem && {
        redemeedStatus: redeem,
      }),
      ...(state && { state: state }),
      ...(township && { township: township }),
    };
    await callback(params);
  };
  return (
    <Modal
      open={visible}
      title={t("page.advance_filter")}
      onOk={sendFilter}
      onCancel={sendFilter}
      okText={t("page.confirm")}
    >
      <Form layout="vertical">
        <Row>
          <Col span={24}>
            <Form.Item label={t("page.region_state")}>
              <Select onChange={handleSelectSate}>
                {Object.keys(region_towship).map((item) => (
                  <Select.Option value={item} key={item}>
                    {t(`page.${item}`)}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Form.Item label={t("page.township")}>
              <Select onChange={handleSelectTownship}>
                {state &&
                  region_towship[state].map((item) => (
                    <Select.Option value={item} key={item}>
                      {item}
                    </Select.Option>
                  ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Form.Item label={t("page.redeemed_status")}>
              <Checkbox.Group style={{ width: "100%" }} onChange={onChangeStatus}>
                {redeemStatus.map((item) => (
                  <Col span={6}>
                    <Checkbox value={item}>{item}</Checkbox>
                  </Col>
                ))}
                <Col span={12} />
              </Checkbox.Group>
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Form.Item label={t("page.coupon_status")}>
              <Checkbox.Group style={{ width: "100%" }} onChange={onChangeCouponStatus}>
                {couponStatus.map((item) => (
                  <Col span={6}>
                    <Checkbox value={item}>{item}</Checkbox>
                  </Col>
                ))}
                <Col span={6} />
              </Checkbox.Group>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};
